import { buildAxiosClient } from '../axiosClient';
import type { AxiosPromise } from 'axios';
import type { Summernote } from './summernote';

export default class SummernoteClient {
  create(blob: Blob): AxiosPromise<Summernote> {
    const data = new FormData();
    data.append('summernote[image]', blob);
    return buildAxiosClient().post('/api/v1/summernotes', data);
  }

  createMy(blob: Blob): AxiosPromise<Summernote> {
    const data = new FormData();
    data.append('summernote[image]', blob);
    return buildAxiosClient().post('/my/summernotes', data);
  }
}
